import * as React from 'react';
import { Api } from '../../../typings/api';
import { GalleryInfosState } from '../../../containers/Gallery/reducer';
import DriveItemUtils, { ResolutionDisplayType, ActionButtonStyle } from '../../../utils/driveItem';
import DriveItemInfoButton from '../../DriveItem/InfoButton';
import DriveItemDownloadButton from '../../DriveItem/DownloadButton';
import DriveItemFavoriteIcon from '../../Favorites/favoriteIcon';
import ShareButton, { ShareOrigin } from '../../Share/ShareButton';
import { StyledTheaterFooter, Extension, Label, ActionIcons } from './styles';
import UserAgentUtils from '../../../utils/userAgent';
import DriveItemDeleteButton from '../../DriveItem/DeleteButton';

export interface TheaterFooterProps {
	driveItem: Api.DriveItem;
	galleryInfos: GalleryInfosState;
	isDownloaded: boolean;
	isRequired: boolean;
}

const TheaterFooter = (props: TheaterFooterProps) => {

	const { driveItem, galleryInfos, isDownloaded, isRequired } = props;
	const extension = DriveItemUtils.getExtension(driveItem);
	const label = DriveItemUtils.getLabel(driveItem);

	const { sharedMethods } = galleryInfos.template;
	const isMobileApp = UserAgentUtils.isMobileApp;
	const isSafariMobile = UserAgentUtils.isSafari() && (!UserAgentUtils.isDesktop() && !isMobileApp);
	const isOnline = UserAgentUtils.isOnline();
	const hasDownloadRights = sharedMethods && sharedMethods.includes(Api.ShareMethod.Download);
	const hasShareRights = sharedMethods && sharedMethods.includes(Api.ShareMethod.Share);

	const isDownloadable = hasDownloadRights && isOnline && (!isMobileApp || !isDownloaded) && !isSafariMobile;
	const isShareable = hasShareRights;

	return (
		<StyledTheaterFooter>
			<Extension>{extension}</Extension>
			<Label>{label}</Label>
			<ActionIcons>
				{ isDownloadable &&
					<DriveItemDownloadButton driveItems={[driveItem]} style={ActionButtonStyle.IconBold} />
				}
				{ isDownloaded && !isRequired &&
					<DriveItemDeleteButton driveItem={driveItem} style={ActionButtonStyle.Icon}/>
				}
				{ isShareable &&
					<ShareButton driveItems={[driveItem]} isBold={true} shareOrigin={ShareOrigin.Theater}/>
				}
				<DriveItemFavoriteIcon itemId={driveItem.id} displayMode={ResolutionDisplayType.Theater} />
				<DriveItemInfoButton driveItem={driveItem} />
			</ActionIcons>
		</StyledTheaterFooter>
	);
};

export default TheaterFooter;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/Footer/index.tsx